import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M21 5.5H1V4h20v1.5ZM21 11.5H1V10h20v1.5ZM1 17.5h20V16H1v1.5Z" />
  </svg>
);
